<template>

  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
 import $ from 'jquery'
export default {
  name: 'App',

  computed:{
    keepAlive(){
      return this.$route.path;
    }
  },


  watch: {
    '$route': {
        immediate: true,
        deep: true,
        handler(val){
          window.scrollTo(0,0);
          console.log(val.path);
          if( val.path == '/'){
            // this.gray()
          }else{
          this.mormal()
          }
        }
      },
  },
  methods:{
      gray(){
        $("html").css({
        '-webkit-filter': 'grayscale(100%)',
        '-moz-filter': 'grayscale(100%)',
        '-ms-filter': 'grayscale(100%)',
        '-o-filter': 'grayscale(100%)',
        // ie滤镜
        'filter': 'progid:DXImageTransform.Microsoft.BasicImage(grayscale=1)',
        // ie6 等低版本浏览器不需要加滤镜
        '_filter': 'none' });
      },
      mormal(){
        $("html").css({
        '-webkit-filter': 'none',
        '-moz-filter': 'none',
        '-ms-filter': 'none',
        '-o-filter': 'none',
        // ie滤镜
        'filter': 'none',
        // ie6 等低版本浏览器不需要加滤镜
        '_filter': 'none' });
      },
     
    },
}
</script>

<style>
div{
  display:block;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
  font-size: 14px;
  line-height: 30px;
  /* text-align: justify; */
  color: #737373;
}

  body {
    margin: 0px !important;
  }
  .el-carousel__button {
    opacity: 1 !important;
    width: 34px !important;
    height: 5px !important;
    border-radius: 6px !important;
    left: 25px !important;
  }
  .el-carousel__indicators--horizontal {
    bottom: 0 !important;
    left: 20px !important;
    -webkit-transform: translateX(0) !important;
    transform: translateX(0) !important;
  }
  .el-carousel__indicator.is-active button {
    background-color: #bd0c16 !important;
  }
    .el-tabs__item {
    font-size: 18px !important;
    padding: 0px 12px !important;
  }
  .el-tabs__nav-wrap::after {
    background-color: #fff !important;
  }
 
  .el-tabs__item.is-active {
    color: #4b4b4b !important;
    font-weight: bold !important;
    font-size: 20px !important;
  }
  .el-tabs__active-bar {
    background-color: #bd0c16 !important;
  }

    /* .el-tabs__active-bar:hover
    .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2), .el-tabs--bottom .el-tabs__item.is-top:nth-child(2), .el-tabs--top .el-tabs__item.is-bottom:nth-child(2), .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      font-size: 24px !important;
      font-weight: bold !important;
    } */
  .el-tabs__item:active, .is-top:hover {
    color: #bd0c16 !important;
  }
  .year-list .el-tabs__header {
    margin-top: 5px !important;
    margin-bottom: 0px !important;
  }
  .year-list .el-tabs__nav-next, .year-list .el-tabs__nav-prev {
    font-size: 18px !important;
    color: #bd0c16 !important;
    font-weight:bold;
  }
  /* .year-list .el-tabs__active-bar:hover .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2), .el-tabs--bottom .el-tabs__item.is-top:nth-child(2), .el-tabs--top .el-tabs__item.is-bottom:nth-child(2), .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    font-size: 20px !important;
    font-weight: bold !important;
    color:#bd0c16!important;
  } */
  .monitor-yt-popover {
    border: none !important;
    padding: 0px !important;
    background: none !important;
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 10%) !important;
    width: 80px;
  }
    .monitor-yt-popover .popper__arrow {
      display: none
    }
  .mag-list .el-table td.el-table__cell {
    border-bottom: none !important;
  }
  .mag-list  .el-table__header{
      display:none;
  }
  .mag-list  .el-table__body-wrapper{
      padding-top:30px;
  }
  .web-info{
     width:100%;
     background-color:#f1f1f1;
     padding:2px 0px 0px 1px;
     box-sizing:border-box;

  }
  .web-info .el-tabs--left .el-tabs__header.is-left {
    width: 300px;
    margin-right:0px!important;
  }
  .web-info .el-tabs--left .el-tabs__item.is-left {
    text-align: center !important;
    height:60px;
    line-height:60px;
  }
  .web-info .el-tabs__item.is-active {
    background-color:#fff!important;
  }
  .web-info .el-tabs__nav-wrap:after{
      background:#f1f1f1!important;
  }
  .web-info .el-tabs--left .el-tabs__active-bar.is-left {
      right:auto;
      left:0px;
  }
    .web-info .el-tabs__content {
      background-color: #fff !important;
      padding:0px 50px;
    }
  .el-tabs__item:hover{
      color:#bd0c16;
  }
  .el-footer{
      padding:0px!important;
  }
  /* .content_s .el-empty__description p {
    margin: 0;
    font-size: 66px !important;
    font-family:Arial, Helvetica, sans-serif;
    font-weight:600;
    color: #bd0c16 !important;
  } */
    .listsearch-item .el-tabs__active-bar {
    display: none !important;
  }
  .el-button--primary:focus, .el-button--primary:hover{
   background-color:#bd0c16;
   color:#fff;
   border: 1px solid #bd0c16;
  }
  .el-loading-spinner .el-loading-text,.el-loading-spinner i{
    color:#bd0c16!important;
  }
  .top h1 a{line-height: 40px!important;}

  .top p span{ine-height: 22px;margin: 0px!important;}

  #js_content section {margin-bottom: 15px!important;}
  .carouse12 .el-carousel__button{
    opacity: 1 !important;
    width: 5px !important;
    height: 5px !important;
    border-radius: 6px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue